import { benchmarksMutationTypes } from './mutation-types';

export const mutations = {
  [benchmarksMutationTypes.ADD_BENCHMARKS_LIST] (state, list) {
    state.benchmarks = list;
  },
  [benchmarksMutationTypes.ADD_CHANNEL_LIST] (state, list) {
    state.channels = list;
  },
  [benchmarksMutationTypes.ADD_PAGE_GROUPS] (state, pageGroups) {
    state.pageGroups = pageGroups;
  },
  [benchmarksMutationTypes.ADD_COLOR_LIST] (state, colorList) {
    state.colorList = colorList;
  },
};
